import { DETAILS_POUP_TABS } from '../constants/tabs';

// Tabs that show the company details payload: nothing to show without details access.
const DETAILS_TABS = new Set([
  DETAILS_POUP_TABS.SHAREHOLDER_STRUCTURE,
  DETAILS_POUP_TABS.KEY_CONTACTS,
  DETAILS_POUP_TABS.BANKS
]);

/**
 * Whether a tab opened from a link (or restored on back navigation) has nothing to show, so the
 * page lands on General instead: the shareholder structure, key contacts and banks need details
 * access, and Banks needs banks. Call it once access and banks are known (after the details
 * request, or when access is denied); the tab buttons themselves are disabled the same way.
 *
 * @param {string} tab - a DETAILS_POUP_TABS value
 * @param {{canViewDetails: boolean, bankConnections?: Array}} context
 * @returns {boolean}
 */
export const isTabUnavailable = (tab, { canViewDetails, bankConnections }) => {
  if (DETAILS_TABS.has(tab) && !canViewDetails) return true;
  return tab === DETAILS_POUP_TABS.BANKS && !bankConnections?.length;
};
